import { BalancesPermission, MemberPermission, OrganizationPermission, PropertyPermission, UserPermission } from '../enums/permissions.enums';
import { DashboardQuickAction } from '../models/ui/dashboard.model';

export class DashboardConstants {

	//#region Quick Actions

	static readonly STAFF_GLOBAL_QUICK_ACTIONS: DashboardQuickAction[] = [
		{
			label: 'Create User',
			icon: 'user-plus',
			routerLink: '/users',
			queryParams: { action: 'add' },
			permissions: [UserPermission.Create],
			userPermissionOnly: true
		},
		{
			label: 'Create Organization',
			icon: 'building-circle-arrow-right',
			routerLink: '/organizations',
			queryParams: { action: 'add' },
			permissions: [OrganizationPermission.Create],
			userPermissionOnly: true
		}
	];

	static readonly STAFF_ORG_QUICK_ACTIONS: DashboardQuickAction[] = [
		{
			label: 'Create Member',
			icon: 'user-plus',
			routerLink: '/members',
			queryParams: { action: 'add' },
			permissions: [MemberPermission.Create]
		},
		{
			label: 'Create Property',
			icon: 'house-circle-check',
			routerLink: '/properties',
			queryParams: { action: 'add' },
			permissions: [PropertyPermission.Create]
		},
		{
			label: 'Create Invoice',
			icon: 'file-invoice-dollar',
			routerLink: '/invoice-schedules/create',
			permissions: [BalancesPermission.CreateChargeSchedules]
		}
	];

	static readonly ADMIN_QUICK_ACTIONS: DashboardQuickAction[] = [
		{
			label: 'Create Member',
			icon: 'user-plus',
			routerLink: '/members',
			queryParams: { action: 'add' },
			permissions: [MemberPermission.Create]
		},
		{
			label: 'Create Property',
			icon: 'house-circle-check',
			routerLink: '/properties',
			queryParams: { action: 'add' },
			permissions: [PropertyPermission.Create]
		},
		{
			label: 'Create Invoice',
			icon: 'file-invoice-dollar',
			routerLink: '/invoice-schedules/create',
			permissions: [BalancesPermission.CreateChargeSchedules]
		}
	];

	//#endregion

	//#region Stat Card Icons

	static readonly ICON_USERS = 'users';
	static readonly ICON_ORGANIZATIONS = 'buildings';
	static readonly ICON_MEMBERS = 'people-group';
	static readonly ICON_PROPERTIES = 'house';

	//#endregion

	//#region Defaults

	static readonly RECENT_LIST_TAKE = 5;
	static readonly SKELETON_ROWS = 5;

	//#endregion
}
